import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'over-ptrn',
    templateUrl: 'over-ptrn.html'
})
export class OverPTRN implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/pages/over-ptrn/over-ptrn.ts